import React, { useEffect, useState } from "react";
import "./ActionPlan.css";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { collection, addDoc, deleteDoc, doc, query, where, getDocs, getDoc } from "firebase/firestore";

const ActionPlan = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem("login") !== "true") {
      navigate("/")
    }
  }, [])
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [actionPlan, setActionPlan] = useState([]);
  const [budgetData, setBudgetData] = useState({
    ageneral: 0, ascsp: 0, anicra: 0, acfldo: 0, acfldp: 0, anf: 0, asponsored: 0, anabard: 0, aarya: 0, aosmv: 0, aseedhub: 0, aatma: 0, auniversity: 0,
    ugeneral: 0, uscsp: 0, unicra: 0, ucfldo: 0, ucfldp: 0, unf: 0, usponsored: 0, unabard: 0, uarya: 0, uosmv: 0, useedhub: 0, uatma: 0, uuniversity: 0,
    bgeneral: 0, bscsp: 0, bnicra: 0, bcfldo: 0, bcfldp: 0, bnf: 0, bsponsored: 0, bnabard: 0, barya: 0, bosmv: 0, bseedhub: 0, batma: 0, buniversity: 0,
  });

  const name = localStorage.getItem("empname");
  const empId = localStorage.getItem("empid");


  // Fetch budget data from Firestore
  const fetchBudgetData = async () => {
    try {
      const budgetRef = doc(db, "empmaster", empId, String(document.getElementById("dd3").value), "budget");
      const docSnap = await getDoc(budgetRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setBudgetData({
          ageneral: data.ageneral || 0, ascsp: data.ascsp || 0, anicra: data.anicra || 0, acfldo: data.acfldo || 0, acfldp: data.acfldp || 0, anf: data.anf || 0, asponsored: data.asponsored || 0, anabard: data.anabard || 0, aarya: data.aarya || 0, aosmv: data.aosmv || 0, aseedhub: data.aseedhub || 0, aatma: data.aatma || 0, auniversity: data.auniversity || 0,
          ugeneral: data.ugeneral || 0, uscsp: data.uscsp || 0, unicra: data.unicra || 0, ucfldo: data.ucfldo || 0, ucfldp: data.ucfldp || 0, unf: data.unf || 0, usponsored: data.usponsored || 0, unabard: data.unabard || 0, uarya: data.uarya || 0, uosmv: data.uosmv || 0, useedhub: data.useedhub || 0, uatma: data.uatma || 0, uuniversity: data.uuniversity || 0,
          bgeneral: data.bgeneral || 0, bscsp: data.bscsp || 0, bnicra: data.bnicra || 0, bcfldo: data.bcfldo || 0, bcfldp: data.bcfldp || 0, bnf: data.bnf || 0, bsponsored: data.bsponsored || 0, bnabard: data.bnabard || 0, barya: data.barya || 0, bosmv: data.bosmv || 0, bseedhub: data.bseedhub || 0, batma: data.batma || 0, buniversity: data.buniversity || 0,
        });
      } else {
        console.log("No budget data found.");
      }
    } catch (error) {
      console.error("Error fetching budget data:", error);
    }
  };


  useEffect(() => {
    const fetchActionPlan = async () => {
      if (!month || !year) return;
      try {
        console.log("Fetching action plans for month:", month);
        const q = query(collection(db, "actionplan"), where("empid", "==", empId), where("month", "==", String(month + " " + year)), where("notesheettype", "==", "special"));
        const querySnapshot = await getDocs(q);
        if (querySnapshot.empty) {
          console.log("No action plans found for the selected month.");
          setActionPlan([]);
          return;
        }
        const actions = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          code: doc.data().programCode || "",
          text: doc.data().program || "",
          budgethead: doc.data().budgethead || "",
          saved: true,
        }));
        console.log("Fetched action plans:", actions);
        setActionPlan(actions);
      } catch (error) {
        console.error("Error fetching action plans:", error);
      }
    };
    fetchActionPlan();
  }, [month, year]);

  const handleAddAction = () => {
    setActionPlan([...actionPlan, { code: "", text: "", budgethead: "", saved: false, id: null }]);
  };

  const handleSaveAction = async (index) => {
    if (!month || actionPlan[index].text.trim() === "" || actionPlan[index].code.trim() === "" || !actionPlan[index].budgethead) {
      alert("Please select a month, budget head, and enter both program code and program name before saving.");
      return;
    }
    try {
      const docRef = await addDoc(collection(db, "actionplan"), {
        empid: empId,
        month: month + " " + year,
        programCode: actionPlan[index].code,
        program: actionPlan[index].text,
        budgethead: actionPlan[index].budgethead,
        currentstatus: 'Action Initiated',
        notesheettype: "special",

        acsettlement: 'No',
        cs: 0,
        scm: 0,
        scf: 0,
        stm: 0,
        stf: 0,
        othm: 0,
        othf: 0,
        total: 0,
        picurl: "",
        tsurl: "",
        prgvenue: "",
        demanddate: new Date(),
        ddodate: new Date(),
        deedate: new Date(),
        ddoremarks: "",
        deeremarks: "",
        vcapproval: "No",
        budgetapproved: 0,
        kvk: String(localStorage.getItem("kvk")),
        empname: String(localStorage.getItem("empname")),
        empdesig: String(localStorage.getItem("empdesig")),
      });
      const updatedActions = [...actionPlan];
      updatedActions[index].saved = true;
      updatedActions[index].id = docRef.id;
      setActionPlan(updatedActions);
    } catch (error) {
      console.error("Error saving program:", error);
    }
  };

  const handleDeleteAction = async (index) => {
    if (window.confirm("Do you want to delete the action plant?")) {
      if (actionPlan[index].id) {
        try {
          await deleteDoc(doc(db, "actionplan", actionPlan[index].id));
        } catch (error) {
          console.error("Error deleting program:", error);
        }
      }
      const updatedActions = actionPlan.filter((_, i) => i !== index);
      setActionPlan(updatedActions);
    }
  }
  const handleBack = (e) => {
    e.preventDefault();
    navigate(-1)
  }
  return (
    <div className="container">
      <h1 className="welcome">Action Plan of {name || "User"}</h1>
      <center><select className="dropdown" id="dd3" onChange={(e) => fetchBudgetData(e.target.value)} style={{ width: '300px', height: '40px', marginTop: '0px' }}>
        <option value="">Select Financial Year</option>
        {["2024-25", "2025-26", "2026-27", "2027-28"].map((m) => (
          <option key={m} value={m}>{m}</option>
        ))}
      </select>
      </center>
      {/* Budget Summary Table */}
      <table className="budget-table">
        <thead>
          <tr>
            <th>Budget</th>
            <th>General</th>
            <th>SCSP</th>
            <th>NICRA</th>
            <th>CFLD(O)</th>
            <th>CFLD(P)</th>
            <th>Natural Farming</th>
            <th>Sponsored</th>
            <th>NABARD</th>
            <th>ARYA</th>
            <th>OSMV</th>
            <th>Seed Hub</th>
            <th>ATMA</th>
            <th>Others</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Allocation</td>
            <td>{budgetData.ageneral}</td>
            <td>{budgetData.ascsp}</td>
            <td>{budgetData.anicra}</td>
            <td>{budgetData.acfldo}</td>
            <td>{budgetData.acfldp}</td>
            <td>{budgetData.anf}</td>
            <td>{budgetData.asponsored}</td>
            <td>{budgetData.anabard}</td>
            <td>{budgetData.aarya}</td>
            <td>{budgetData.aosmv}</td>
            <td>{budgetData.aseedhub}</td>
            <td>{budgetData.aatma}</td>
            <td>{budgetData.auniversity}</td>
          </tr>
          <tr>
            <td>Utilized</td>
            <td>{budgetData.ugeneral}</td>
            <td>{budgetData.uscsp}</td>
            <td>{budgetData.unicra}</td>
            <td>{budgetData.ucfldo}</td>
            <td>{budgetData.ucfldp}</td>
            <td>{budgetData.unf}</td>
            <td>{budgetData.usponsored}</td>
            <td>{budgetData.unabard}</td>
            <td>{budgetData.uarya}</td>
            <td>{budgetData.uosmv}</td>
            <td>{budgetData.useedhub}</td>
            <td>{budgetData.uatma}</td>
            <td>{budgetData.uuniversity}</td>
          </tr>
          <tr>
            <td>Balance</td>
            <td>{budgetData.ageneral - budgetData.ugeneral}</td>
            <td>{budgetData.ascsp - budgetData.uscsp}</td>
            <td>{budgetData.anicra - budgetData.unicra}</td>
            <td>{budgetData.acfldo - budgetData.ucfldo}</td>
            <td>{budgetData.acfldp - budgetData.ucfldp}</td>
            <td>{budgetData.anf - budgetData.unf}</td>
            <td>{budgetData.asponsored - budgetData.usponsored}</td>
            <td>{budgetData.anabard - budgetData.unabard}</td>
            <td>{budgetData.aarya - budgetData.uarya}</td>
            <td>{budgetData.aosmv - budgetData.uosmv}</td>
            <td>{budgetData.aseedhub - budgetData.useedhub}</td>
            <td>{budgetData.aatma - budgetData.uatma}</td>
            <td>{budgetData.auniversity - budgetData.uuniversity}</td>
          </tr>
        </tbody>
      </table>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label className="label">Select Month and Year:</label>
          <select className="dropdown" id="dd1" value={month} onChange={(e) => setMonth(e.target.value)}>
            <option value="">Month</option>
            {["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map((m) => (
              <option key={m} value={m}>{m}</option>
            ))}
          </select>
        </div>
        &nbsp;
        <select className="dropdown" id="dd2" value={year} onChange={(e) => setYear(e.target.value)} style={{ width: '150px', height: '40px', marginTop: '33px' }}>
          <option value="">Year</option>
          {["2025", "2026", "2027", "2028"].map((m) => (
            <option key={m} value={m}>{m}</option>
          ))}
        </select>
      </div>

      {month && (
        <div className="action-section">
          <table className="action-table">
            <thead>
              <tr>
                <th style={{ width: '120px' }}>Budget Head</th>
                <th style={{ width: '150px' }}>Program Code</th>
                <th>Subject / Title of the Program</th>
                <th style={{ width: '120px' }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {actionPlan.map((action, index) => (
                <tr key={index}>
                  <td>
                    <select
                      style={{ height: '38px', backgroundColor: 'white' }}
                      value={action.budgethead}
                      onChange={(e) => {
                        const updatedActions = [...actionPlan];
                        updatedActions[index].budgethead = e.target.value;
                        setActionPlan(updatedActions);
                      }}
                      disabled={action.saved}
                    >
                      <option value="">Select</option>
                      <option value="General">General</option>
                      <option value="SCSP">SCSP</option>
                      <option value="NICRA">NICRA</option>
                      <option value="CFLD Oilseed">CFLD Oilseed</option>
                      <option value="CFLD Pulse">CFLD Pulse</option>
                      <option value="Natural Farming">Natural Farming</option>
                      <option value="Sponsored Program">Sponsored Program</option>
                      <option value="NABARD">NABARD</option>
                      <option value="ARYA">ARYA</option>
                      <option value="Oilseed Mission Village">Oilseed Mission Village</option>
                      <option value="Seed Hub">Seed Hub</option>
                      <option value="ATMA">ATMA</option>
                      <option value="Others">Others</option>
                    </select>
                  </td>
                  <td>
                    <input type="text" value={action.code} onChange={(e) => {
                      const updatedActions = [...actionPlan];
                      updatedActions[index].code = e.target.value;
                      setActionPlan(updatedActions);
                    }} className="input-box" disabled={action.saved} />
                  </td>
                  <td>
                    <input type="text" value={action.text} onChange={(e) => {
                      const updatedActions = [...actionPlan];
                      updatedActions[index].text = e.target.value;
                      setActionPlan(updatedActions);
                    }} className="input-box" disabled={action.saved} />
                  </td>
                  <td>
                    <button className={action.saved ? "delete-btn" : "save-btn"} onClick={() => (action.saved ? handleDeleteAction(index) : handleSaveAction(index))}>
                      {action.saved ? "Delete" : "Save"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <button className="add-btn" onClick={handleAddAction}>Add Program</button>
        </div>
      )}
      <img src="/assets/back.png" style={{ width: '100px' }} onClick={handleBack} alt="" />

    </div>
  );
};

export default ActionPlan;
